<template>
  <button type="button" class="btn-white">
    <i class="fa-solid fa-plus" />
    <span class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "NewButton",
  props: ["label"],
};
</script>